import { render, staticRenderFns } from "./SignatureReport.vue?vue&type=template&id=871294e0&"
import script from "./SignatureReport.vue?vue&type=script&lang=js&"
export * from "./SignatureReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports